"use strict";

require("./CompanyPublicationService");

function CompanyPublicationsListWatchedCtrl($scope, $state, $stateParams, publications, translations) {
  $scope.more         = publications.length > 20;
  $scope.publications = publications.slice(0, 20);
  $scope.page         = $stateParams.page|0;
  $scope.title        = translations["publication.your-watched-publications"];
  $scope.listWatching = true;

  $scope.filter = {};
  if ($stateParams.queryWatched) {
    $scope.filter.q = $stateParams.queryWatched;
  }

  $scope.searchPublications = function() {
    $state.go('.', {
      companyId: $stateParams.companyId,
      queryWatched: $scope.filter.q
    });
  };
}

module.exports = {
  resolve: {
    publications: ["$stateParams", "CurrentUserService", "CompanyPublicationService", function($stateParams, currentUser, publications) {
      return currentUser.get().then(function(u) {
        var filter = {
          userId:    u.id,
          companyId: $stateParams.companyId,
          limit:     21,
          offset:    ($stateParams.page|0) * 20,
          q: $stateParams.queryWatched || null
        };

        return publications.queryWatched(filter).$promise;
      });
    }],
    translations: ["$translate", function($translate) {
      return $translate(["publication.your-watched-publications"]);
    }]
  }
};

angular.module("dokiv")
  .controller("CompanyPublicationsListWatchedCtrl", ["$scope", "$state", "$stateParams", "publications", "translations", CompanyPublicationsListWatchedCtrl]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationsListWatchedCtrl.js
// module id = 388
// module chunks = 0